import React from 'react';

import Text from '/component/base/Text';
import {styles} from '/component/partial/report/BonusEligibleUntil/BonusEligibleUntil.style';
import {Reports} from '/constant/TestIDs';
import {generateComponentCallback} from '/util/component.util';

export const getEligibleDays = ({daysLeft, tt}: any) => {
  if (daysLeft > 1) {
    return tt(
      'eligibleSomeDaysLeft',
      generateComponentCallback({
        component: (
          <Text testID={Reports.reportEligibleUntil}>{daysLeft} days left</Text>
        ),
      }),
    );
  } else if (daysLeft === 1) {
    return tt(
      'eligibleOneDayLeft',
      generateComponentCallback({
        component: <Text testID={Reports.reportEligibleUntil}>1 day left</Text>,
      }),
    );
  } else {
    return tt(
      'eligibleNoDayLeft',
      generateComponentCallback({
        component: (
          <Text testID={Reports.reportEligibleUntil} style={styles.lastDayText}>
            Last Day For Eligibility
          </Text>
        ),
      }),
    );
  }
};
